import React, { Suspense } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { MessageOptions } from 'domain/interfaces/redux/message';
import { ownProps } from './interface';
import { ConnectComponent } from './mapper/mapperMessage';

import AuditRecordDrawer from '../AuditRecord';
import AppointmentWithdrew from '../modalsSAC/AppointmentWithdrew';
import FinishAppointmentSAC from '../modalsSAC/FinishAppointment';
import { HelpLine } from '../modalsSAC/HelpLine/HelpLine';
import { IncorporationCode } from '../modalsSAC/IncorporationCode/IncorporationCode';
import NotesHistory from '../modalsSAC/NotesHistory';
import { SupportInformation } from '../modalsSAC/SupportInformation/SupportInformation';
import RecurringConferenceModal from '../recurringConferenceModal';
import { ChooseSubjectModal } from '../sac/ChooseSubjectModal';
import AdvConfigModal from './advConfig';
import ConferenceAccessDenied from './conferenceAccessDenied';
import ConfirmModal from './confirm';
import ErrorModal from './error';
import ExternalLoginError from './externalLoginError';
import FirstAccessModal from './firstAccess';
import InfoMarkdownModal from './infoMarkdown';
import InstantConference from './instantConference';
import SacProfessionalReady from './sacProfessionalReady';
import SelectBondAdmin from './selectBondAdmin';
import SuccessModal from './success';

const Notifications: React.FC<ownProps> = ({
  children,
  message,
}): JSX.Element => {
  const LoadingCircularProgress = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  };
  return (
    <>
      <Suspense fallback={<LoadingCircularProgress />}>
        <SelectBondAdmin message={message} />
        <SuccessModal message={message} />
        <ErrorModal message={message} />
        <ConfirmModal message={message} />
        <InfoMarkdownModal message={message} />
        <FirstAccessModal message={message} />
        <AdvConfigModal message={message} />
        <AuditRecordDrawer message={message} />
        <InstantConference message={message} />
        <ConferenceAccessDenied message={message} />
        <ExternalLoginError message={message} />
        <RecurringConferenceModal message={message} />
        <FinishAppointmentSAC message={message} />
        <AppointmentWithdrew message={message} />
        <NotesHistory message={message} />
        <ChooseSubjectModal message={message} />
        {message.active === MessageOptions.sacProfessionalReady && (
          <SacProfessionalReady message={message} />
        )}
        <SupportInformation message={message} />
        <IncorporationCode message={message} />
        <HelpLine message={message} />
        {children}
      </Suspense>
    </>
  );
};

export default ConnectComponent(Notifications);
